/** Shared CTA classes — one primary, one secondary, one ghost. */
export const homeCta = {
  primary:
    'inline-flex items-center justify-center px-6 py-3 rounded-full bg-gradient-to-r from-[#3B3B98] to-[#9B59B6] text-white text-sm font-semibold shadow-sm hover:shadow-md transition-all',
  primaryCompact:
    'inline-flex items-center justify-center px-5 py-2.5 rounded-full bg-gradient-to-r from-purple-600 to-indigo-600 text-white font-semibold shadow-sm hover:shadow-md hover:from-purple-700 hover:to-indigo-700 transition-all',
  secondary:
    'inline-flex items-center justify-center px-6 py-3 rounded-full border border-slate-200 bg-white text-slate-900 font-semibold hover:bg-slate-50 transition',
  secondaryOnDark:
    'inline-flex items-center justify-center px-6 py-3 rounded-xl bg-white text-slate-900 font-semibold hover:bg-white/90 transition-colors',
  ghost:
    'inline-flex items-center justify-center text-sm font-semibold text-indigo-700 hover:text-indigo-800',
} as const;
